import Vue from "vue";
import Router from "vue-router";
import store from "../services/store.provider";
import ExceptionRouter from "./exception.router";
import PagesRouter1 from "./pages1.router";
import LoginRouter from "./login.router";
import layout1 from "@/pages/views/layout/layout1";
import blank from "@/pages/views/layout/blank";

Vue.use(Router);

const appRouter = new Router({
  mode: "history",
  routes: [
    {
      path: "/full-cockpit",
      component: () => import("@/pages/views/projectOverview/full-cockpit"),
      meta: {
        auth: true
      }
    },
    {
      path: "/",
      component: layout1,
      children: [...PagesRouter1]
    },
    {
      path: "/",
      component: blank,
      children: [...LoginRouter, ...ExceptionRouter]
    }
  ]
});

appRouter.beforeEach((to, from, next) => {
  if (to.path === "/timeout") {
    next({
      path: to.query.redirect
    });
  }
  if (to.meta.auth) {
    if (store.state.login.userInfo.userid) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    if (to.fullPath === "/" || to.fullPath === "") {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
      return;
    }
    next();
  }
});
export default appRouter;



// WEBPACK FOOTER //
// ./src/router/index.js